export const ASSET_INSTALLABILITY_QUERY_FIELD_NAME = 'assetInstallability';